var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreviewImageAttachment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.7695 19H5.76953V5H19.7695M19.7695 3H5.76953C5.2391 3 4.73039 3.21071 4.35532 3.58579C3.98024 3.96086 3.76953 4.46957 3.76953 5V19C3.76953 19.5304 3.98024 20.0391 4.35532 20.4142C4.73039 20.7893 5.2391 21 5.76953 21H19.7695C20.3 21 20.8087 20.7893 21.1837 20.4142C21.5588 20.0391 21.7695 19.5304 21.7695 19V5C21.7695 4.46957 21.5588 3.96086 21.1837 3.58579C20.8087 3.21071 20.3 3 19.7695 3ZM14.7295 12.29L11.9795 15.83L10.0195 13.47L7.26953 17H18.2695L14.7295 12.29Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewImageAttachment);
export default __webpack_public_path__ + "static/media/preview_image_attachment.307d44cda928ad12146ae8fa3cf5f9c9.svg";
export { ForwardRef as ReactComponent };